<!--
This component requires certain dependencies that must be provided
from outside of Vue. Some (e.g. globalConfig/flyerlineConfig) are put in
the Vue context right here in the root component, others (e.g. Selectric)
are only used further down the line through a wrapper component.
-->
<template lang="html">
  <div>
    <div v-if="initializing" class="skeleton skeleton2"/>

    <div v-else class="row product">
      <div class="small-12 large-9 column v-spacing-child-6@large">
        <template v-for="(group, index) in configuratorService.observableData.data.configgroups">
          <ProductIsland v-if="index===0" :key="group.title">
            <OptionGroupMain :data="group">
              <ConfigOptions
                  :group="group"
                  :baseWidth="6"
                  :doubleWidthAllowed="true">
                <template v-slot:top>
                  <PrintQFields v-if="configuratorService.isConfigTypePresent(printqService.TYPE)" />
                </template>
              </ConfigOptions>
              <div class="mt-1" v-if="configuratorService.observableData.data.text" v-html="configuratorService.observableData.data.text"></div>
            </OptionGroupMain>
          </ProductIsland>
          <OptionGroupGeneral v-else v-show="configuratorService.showGroup(group)" :group="group" :key="group.title">
            <ConfigOptions
                :group="group"
                :baseWidth="4"
                :doubleWidthAllowed="false"
            />

                    </OptionGroupGeneral>
                </template>
            </div>

      <div class="small-12 large-3 column sticky-container">
        <div class="sticky" data-margin-top="0">
          <PriceBox :shopItemId="shopItemId" />

          <ButtonGroup>
            <PrintQButtonGroup v-if="this.configuratorService.isConfigTypePresent(printqService.TYPE)" />

            <CreateXButtonGroup v-if="this.configuratorService.isConfigTypePresent('CreateX')" />

            <PrintOfferButton/>

            <SaveProductConfigurationButton :configInvalid="customizationInvalid"/>

            <SendProductOfferButton :configInvalid="customizationInvalid"/>

            <div> <!-- Leave this div here -->
              <DatenblattButton/>
              <OrderSampleButton/>
            </div>

          </ButtonGroup>
        </div>
      </div>

          <DownloadSection :vorlagen="configuratorService.observableData.data.gestaltungsvorlagen"/>

        </div>

    </div>
</template>

<script>
import DownloadSection from "components/DownloadSection.vue";
import OptionGroupMain from "components/OptionGroupMain.vue";
import OptionGroupGeneral from "components/OptionGroupGeneral.vue";

import PriceBox from "components/PriceBox.vue";
import ProductIsland from "components/ProductIsland.vue";
import ConfigurableProductMixin from "pages/mixins/ConfigurableProductMixin";
import ButtonGroup from "components/sidebarbuttons/ButtonGroup";
import PrintOfferButton from "components/sidebarbuttons/PrintOfferButton";
import SaveProductConfigurationButton from "components/sidebarbuttons/SaveProductConfigurationButton";
import SendProductOfferButton from "components/sidebarbuttons/SendProductOfferButton";
import DatenblattButton from "components/sidebarbuttons/DatenblattButton";
import OrderSampleButton from "components/sidebarbuttons/OrderSampleButton";
import {PrintQService} from "./classes/printQService";
import ConfigOptions from "components/Configoptions";
import PrintQFields from "components/PrintQFields";
import PrintQButtonGroup from "./components/PrintQButtonGroup";

import {ConfiguratorService} from "./services/configurator.service";
import CreateXButtonGroup from "./components/CreateXButtonGroup";

export default {
  props: {
    configId: {
      type: String,
      required: false
    },
    shopItemId: {
      type: Number,
      required: false
    }
  },
  data() {
    return {
      configuratorService: new ConfiguratorService(),
      printqService: new PrintQService()

    };
  },
  provide() {
    return {
      configuratorService: this.configuratorService,
      printqService: this.printqService,
      shopItemId: this.shopItemId
    }
  },
  created() {
    this.configuratorService.setLanguage(this.globalConfig.locale.split("_", 1)[0]);
    this.configuratorService.setProductId(this.globalConfig.productId);
    this.configuratorService.getConfigurator(this.configId, this.shopItemId).then(() => {
          this.printqService.init(this.configuratorService)
        }, () => {
        }
    );
  },
  components: {
    PrintQButtonGroup,
    PrintQFields,
    ConfigOptions,
    OrderSampleButton,
    DatenblattButton,
    SendProductOfferButton,
    SaveProductConfigurationButton,
    PrintOfferButton,
    ButtonGroup, ProductIsland, OptionGroupMain, OptionGroupGeneral,
    PriceBox, DownloadSection, CreateXButtonGroup
  },
  mixins: [ConfigurableProductMixin],
  methods: {
    //updatemethode für printq?

  },
  computed: {
    urlParams() {
      return "";
    },
    initializing() {
      return Object.keys(this.configuratorService.observableData.data).length === 0
    }
  },
  watch: {
    initializing(val) {
      if (!val) {
        // init sticky, assuming sticky.min.js has been loaded already.
        new Sticky('.sticky');
      }
    }
  }
};


</script>
